module.exports = __webpack_public_path__ + "static/media/Lupa.6437fdbd.svg";